import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { EvseCurrentType } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'StationEvseType',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { tl } = useI18nTl('Operation')



const statusLabel = computed(() => {
  switch (props.state) {
    case EvseCurrentType.ECT_AC:
      return tl('stationAC')
    case EvseCurrentType.ECT_DC:
      return tl('stationDC')
    case EvseCurrentType.ECT_AC_DC:
      return tl('stationDCAC')
  }
  return '-'
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})